<script setup lang="ts">
import type { PropType } from 'vue';
import { computed } from 'vue';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  imgSet: {
    type: Number as PropType<number>,
    required: false,
    default: 1,
  },
  alt: {
    type: String,
    required: false,
  },
});

const srcset = computed(() => {
  if (props.imgSet > 1) {
    const ext = props.src.split('.').pop();
    const fileName = props.src.replace(`.${ext}`, '');
    return `${props.src} 1x, ${fileName}@2x.${ext} 2x, ${fileName}@3x.${ext} 3d`;
  }
  return '';
});
</script>
<template>
	<img :src="props.src" :srcset="srcset" :alt="props.alt" />
</template>
